<template>
	<div class="bor-bot">
		<div class="nav_box ">
			<div class="clearfloat">
				<div @click="xin.goUrl('/index')" class="box_left">
					<img class="go_logo" src="https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/img/20201019/02d3e600d7cb071501623bfa22170a4f6f426bef.png" />
					<div class="logo_title">同仁化学中国欢迎您！</div>
				</div>
				<div class="box_right">
                    <div class="box_go">
                        <div class="goji">
                            Select your Area 
                        </div>
                        <div class="goji" @click="xin.goNew('https://www.dojindo.co.jp/products_en/')">
                            <span title="Asia，Oceania">Asia，Oceania</span>
                        </div>
                        <div class="goji" @click="xin.goNew('https://dojindo.com/')">
                            <span title="Americas">Americas</span>
                        </div>
                        <div class="goji" @click="xin.goNew('https://www.dojindo.eu.com/')" >
                            <span title="Europe">Europe</span>
                        </div>
                        <div class="goji" @click="xin.goNew('https://www.dojindo.co.jp/')">
                            <span title="Japan">Japan</span>
                        </div>
                    </div>
						<!-- <div class="box_go"> -->
                            <!-- <div class="goji">
								Select your Area   Asia，Oceania |
							</div>
                            <div class="goji" @click="xin.goNew('https://www.dojindo.com')">
								Americas
							</div>
                            <div class="goji" @click="xin.goNew('https://www.dojindo.eu.com')" >
								Europe
							</div>
                            <div class="goji" @click="xin.goNew('https://www.dojindo.co.jp')">
								Japan
							</div> -->
							<!-- <div class="goji" @click="xin.goNew('https://www.dojindo.eu.com')" >
								<img title="欧盟" src="https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/go_se.jpg" />
								<span>EU</span>
							</div>
							<div class="goji" @click="xin.goNew('https://www.dojindo.com')">
								<img title="美国" src="https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/go_me.jpg" />
								<span>USA</span>
							</div>
							<div class="goji" @click="xin.goNew('https://www.dojindo.co.jp')">
								<img title="日本" src="https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/go_ri.jpg" />
								<span>JAPAN</span>
							</div> -->
						<!-- </div> -->
					<div class="box_search">
						<el-input @mousedown.stop key="ae" @blur="tosearch(searchVal);isHint=false;" ref="hint" @focus="isHint=true" class="nav_search" v-model="searchVal" @change="tosearch"  select-when-unmatched suffix-icon="el-icon-search" placeholder="请输入内容"></el-input>
						<div @mousedown.prevent v-show="isHint"  class="search_hint" slot="suffix" >
							<div>插入特殊字符：</div>
							<div class="zi_val">
								<span  @click="hint(item)" v-for="(item,i) in hintList" :key="i">{{item}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="nav_menu clearfloat">
				<div class="nav_left">
					<div v-for="(itme,i) in selectList" :key="i" :class="['nav_one',{'nav_one_choose':activeIndex==i}]" @click="skipOne(itme.url,i)">
						{{itme.value}}
						<template v-if="itme.children">
							<span class="icon el-icon-arrow-down"></span>
							<div v-if="itme.url != '/product'" class="nva_tab nav_two_vessel">
								<div v-for="(val,k) in itme.children" :key="i+'-'+k" :class="['nav_tow',{'nav_tow_choose':className==val.url}]"
								 @click.stop="skipOne(val.url,i,k)">{{val.value}}</div>
							</div>
							<!--  -->
							<div v-else class="nva_tow_centen clearfloat" @click.stop="">
								<div class="nva_tow_big">
									<div v-for="(val,k) in classifyList" :key="val.id"
									:class="['nva_big_zi',{'a_dase':val.id==className}]" @click.stop="skipOne(itme.url,i,k,val.id)">{{val.title}}</div>
									<!-- <div v-for="a in 4" :key="a" class="nva_big_zi">asdsadad{{a}}</div> -->
								</div>
							</div>
						</template>
					</div>

				</div>
				<div class="nav_right">
					<template v-if="token">
						<!--  -->
						<span class="red cur_po" @click="quit">安全退出</span>
						<span class="nav_ge">|</span>
						<span class="cur_po" @click="xin.goUrl('/personalCenter/credits')">我的积分</span>
						<span class="nav_ge">|</span>
						<span class="cur_po" @click="xin.goUrl('/personalCenter/orderForm')">我的订单</span>
						<span class="nav_ge">|</span>
						<span class="go users cur_po" @click="xin.goUrl('/personalCenter/personal')">
							<span >
								<span class="iconfont icon-touxiang"></span>
								<span class="el-icon-arrow-down"></span>
							</span>
							<div class="user_li"></div>
							<div class="nva_tab nav_two_vessel">
								<div v-for="(item,i) in userTabs" :key="i" :class="['nav_tow',{'a_dase':className==item.url}]"
								@click.stop="xin.goUrl(item.url)">{{item.name}}</div>
							</div>
						</span>
						<span class="nav_ge">|</span>
						<span @click="xin.goUrl('/shopping')" class="cur_po">
							<span class="iconfont icon-gouwuchekong powder"></span>
							<span>({{goodsCount}})</span>
						</span>
					</template>
					<template v-else>
						<span class="go cur_po" @click="xin.goUrl('/aboutUs/contactUs')">联系我们</span>
						<span class="nav_ge">|</span>
						<span class="go cur_po" @click="xin.goUrl('/login') ">登录</span>
						<span class="nav_ge">|</span>
						<span @click="xin.goUrl('/register')" class="cur_po">注册</span>
						<span class="nav_ge">|</span>
						<span @click="xin.goUrl('/shopping')" class="cur_po">
							<span class="iconfont icon-gouwuchekong powder"></span>
							<span>(0)</span>
						</span>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState,mapMutations,mapActions } from 'vuex'
	export default {
		name: '',
		data() {
			return {
				num: 0,
				// activeIndex: "0",
				searchVal: "",
				isHint:false,//搜索特殊字符提示
				hintList:['α' ,'β' ,'γ' ,'λ' ,'τ' ,'μ' ,'Ⅰ' ,'Ⅱ' ,'Ⅲ' ,'Ⅳ' ,'Ⅴ' ,'Ⅵ' ,'Ⅶ' ,'Ⅷ' ,'Ⅸ' ,'Ⅹ' ,'Ⅴ'],//特殊字符
				selectList: [{
						value: "首页",
						url: "/index",
					},
					{
						value: "产品中心",
						url: "/product",
						children: []
					},
					{
						value: "技术支持",
						url:'/explain',
						children: [{
								value: "说明书下载",
								url: "/explain"
							},
							{
								value: "文献下载",
								url: "/technology"
							},
							{
								value: "学习资料",
								url: "/studyData"
							},
							{
								value: "资料索取",
								url: "/askData"
							},
							{
								value: "实验工具",
								url:'/tool'
							},
							{
								value: "产品视频",
								url: "/video"
							},
						],
					},
					// {
					// 	value: "积分兑换",
					// 	url: "/integral",
					// },
					{
						value:"活动专区",
						url:"/activity"
					},
					{
						value:"新闻动态",
						url:"/journalism/news",
						children:[{
							value: "产品最新动态",
							url: "/journalism/news"
						},{
								value: "文献最新动态",
								url: "/journalism/product"
							},{
								value: "公司新闻",
								url: "/journalism/company"
							},]
					},
					{
						value:"走进同仁",
						url: "/aboutUs/about",
						children:[{
								value: "公司介绍",
								url: "/aboutUs/about"
							},{
								value: "加入我们",
								url: "/aboutUs/joinUs"
							},{
								value: "联系我们",
								url: "/aboutUs/contactUs"
							},{
								value: "订货流程",
								url: "/aboutUs/flow"
							}]
					}
				],
				userTabs: [{
						name: "编辑个人资料",
						url: "/personalCenter/personal"
					},
					{
						name: "VIP申请",
						url: "/personalCenter/applyVip"
					},
					{
						name: "修改密码",
						url: "/personalCenter/changePassword"
					},
					{
						name: "积分信息",
						url: "/personalCenter/credits"
					},
					{
						name: "地址信息管理",
						url: "/personalCenter/site"
					},
					{
						name: "我的留言",
						url: "/personalCenter/leave"
					},
					{
						name: "发票信息管理",
						url: "/personalCenter/invoice"
					},
					{
						name: "我的订单",
						url: "/personalCenter/orderForm"
					},
					{
						name: "积分订单",
						url: "/personalCenter/miOrder"
					},
					{
						name: "我的发票",
						url: "/personalCenter/myInvoice"
					},
					{
						name: "浏览足迹",
						url: "/personalCenter/history"
					}
				]
			};
		},
		components: {},
		computed:{
			...mapState(['token','className','activeIndex','classifyList','goodsCount'])
		},
		watch:{
			$route(to,fo){
				if(to.path == '/search'){
					if(to.query.val)
						this.searchVal = to.query.val.trim()
				}
				switch(to.path) {
					case '/index'://首页
						this.setactiveIndex(0)
						this.setclassName(to.path)
						break;
					case '/product'://产品中心
					case '/oneDetails':
					case '/goodsDetails':
						this.setclassName(to.query.cid)
						this.setactiveIndex(1)
						break;
					case '/explain'://技术支持
					case '/technology':
					case '/studyData':
					case '/askData':
					case '/tool':
					case '/video':
					case '/videoDetails':
						this.setclassName(to.path)
						this.setactiveIndex(2)
					break;
					// case '/integral'://积分兑换
					// case '/activityDetails':
					// 	this.setactiveIndex(3)
					// 	this.setclassName(to.path)
					// break;
					case '/activity'://活动专区
					case '/activityDetails':
						this.setactiveIndex(3)
						this.setclassName(to.path)
					break;
					case '/journalism/product'://新闻动态
					case '/journalism/news':
					case '/journalism/company':
						this.setactiveIndex(4);
						this.setclassName(to.path)
					break;
					case '/aboutUs/about'://走进东仁
					case '/aboutUs/joinUs':
					case '/aboutUs/contactUs':
					case '/aboutUs/flow':
						this.setactiveIndex(5)
						this.setclassName(to.path)
					break;
					default:
						this.setclassName(to.path)
						this.setactiveIndex(100)
				}
			}
		},
		async created() {
			let {data} = await this.api.getoneCalss();
			this.setclassifyList(data);
			this.setgoodsCount();
			let token = localStorage.getItem('token');
			if(token){
				this.settoken(token)
				this.getUser();
			}
		},
		methods: {
			...mapMutations(['setclassName','setactiveIndex','setclassifyList','settoken','setuser','setgoodsCount']),
			...mapActions(['setgoodsCount','getUser']),
			hint(item){
				this.searchVal=this.searchVal+item;
			},
			quit(e) { //退出登录
				this.settoken('');
				localStorage.removeItem('token');
				this.setuser({});
				this.setgoodsCount(0);
				this.xin.goUrl('/index');
				this.xin.setCookie('GsToken','');
				localStorage.removeItem('GsToken')
			},
			tosearch(e){//搜索
				e = e.replace(/^\s*|\s*$/g,"");
				if(e)this.xin.goUrl('/search?val='+encodeURIComponent(e));
			},
			skipOne(url,i,k,val) {
				if(val){
					if(this.$route.query.cname == val)return;
					this.xin.goUrl('/oneDetails?cid='+val);
				}else{
					if(!url)return;
					this.xin.goUrl(url);
					// this.setactiveIndex(i);
					// this.setclassName(url);
				}
				
			}
		},

	}
</script>
<style lang="scss">

</style>
<style lang='scss' scoped>
	input{
		description:''
	}
	.go_logo {
		cursor: pointer;
	}
@keyframes hideIndex {
	0% {
		opacity: 0.5;
		// transform:scale(1,0);
	}
	100% {
		opacity: 1;
		// transform:scale(1,1);
	}
}

	.nav_box {
		padding-top: 39px;
		width: 1200px;
		margin: 0px auto;

		.box_left {
			float: left;

			img {
				width: 212px;
				height: 72px;
			}

			.logo_title {
				margin-top: 15px;
				font-size: 20px;
				font-weight: 400;
				text-align: left;
				color: #444444;
			}
		}

		.box_right {
            height: 120px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
			.box_go {
				margin-bottom: 40px;
                display: flex;
				.goji {
                    font-size: 17px;
                    padding: 0 10px;
                    border-right: 1px solid var(--themeColor);
                    color: #333;
                    span{
                        color: var(--themeColor);
                        cursor: pointer;
                    }
                    &:nth-child(1){
                        padding-left: 25px;
                        border:none;
                    }
                    &:nth-last-child(1){
                        border:none;
                    }
				}

				img {
					width: 30px;
					height: 20px;
				}
			}
			.box_search {
				position: relative;
				width: 446px;
				.search_hint{
					z-index: 9999;
					padding: 10px ;
					width: 416px;
					height: 60px;
					background: #fff;
					position: absolute;
					top: 43px;
					left: 10px;
					box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
					.zi_val{
						color: #005599;
						margin-top: 10px;
						span{
							cursor: pointer;
							padding-right: 10px;;
						}
					}
				}
				/deep/ .el-input .el-input__inner {
					border-radius: 20px;
				}
			}
		}

		/* 小型二级 */
		.nav_two_vessel {
			width: 120px;

			.nav_tow {
				text-align: center;
				line-height: 50px;
				height: 50px;
				font-size: 16px;
				color: #666666;
				font-weight: 500;

				&:hover {
					font-weight: 600;
					color: var(--themeColor);
				}
			}

			.nav_tow_choose {
				font-weight: 600;
				color: var(--themeColor);
			}
		}

		.nva_tab {
			z-index: 9998;
			display: none;
			background: #fff;
			position: absolute;
			top: 76px;
			left: -10px;
			box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
			animation: transform 0.6s;
		}

		/* 导航菜单 */
		.nav_menu {
			height: 76px;
			margin-top: 25px;
			border-top: solid 1px #e6e6e6;

			/* border-top: 1px solid; */
			.nav_left {
				float: left;
				color: #666666;

				.nav_one {
					cursor: pointer;
					float: left;
					width: 100px;
					height: 100%;
					text-align: center;
					line-height: 76px;
					position: relative;
					margin-right: 15px;

					/* 大型二级 */
					.nva_tow_centen {
						display: none;

						.nva_tow_big {
							max-height: 460px;
							width: 930px;
							min-width: 500px;
							overflow-x: auto;
							padding: 40px 0px 40px 40px;
							z-index: 100;
							cursor: default;
							text-align: left;
							line-height: 100%;
							background: #fff;
							position: absolute;
							top: 70px;
							left: -10px;
							box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
							display: flex;
							flex-wrap: wrap;
							flex-direction: column;
							.nva_big_zi {
								color: #333;
								font-size: 20px;
								line-height: 36px;
								padding-left: 10px;
								border-left: #8F8F8F 1px solid;
								height: 36px;
								width: 220px;

								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								&:hover {
									cursor: pointer;
									font-weight: 600;
									color: var(--themeColor);
								}
							}
						}
					}

					.icon {
						transition: transform .3s;
					}

					&:hover .nva_tab,
					&:hover .nva_tow_centen {
						display: block;
						animation: hideIndex 0.6s;
						/* transition: 1s height, 1s width; */
					}
				}

				.nav_one_choose {
					border-top: 3px solid var(--themeColor);
					color: var(--themeColor);
					font-weight: 500;
				}
			}

			.nav_right {

				line-height: 76px;
				color: #444444;
				float: right;
				height: 20px;

				.users {
					position: relative;
					.nva_tab {
						z-index: 1000;
						left: -30px;
						top: 46px;
					}

					.user_li {
						position: absolute;
						top: 0;
						left: 0;
						width: 70px;
						height: 50px;
					}

					&:hover .nva_tab {
						display: block;
						animation: hideIndex 0.6s;
						/* transition: 1s height, 1s width; */
					}
				}

				img {
					width: 23px;
					margin-right: 5px;
				}

				.go {
					color: #2145AD;
				}

			}
		}
	}
</style>
